import { http } from "api/http";

const sendEmailTemplateService = ({ emails, content }) => {
  return http.post(`/communication/sendmail`, { emails, content });
};

const createEmailTemplatessss = (data: any) => {
  return http.post("admin/create-email-template", data);
};

const getEmailTemplates = ({ queryKey }: any) => {
  const [, params] = queryKey;
return http.get("/admin/get-email-template", { params });
};

const deleteEmailTemplate = (id: number) => {
  return http.delete(`/admin/delete-email-template/${id}`);
};

const getOneEmailTemplate = (id:any) => {
  return http.get(`/admin/get-one-emailTemplate/${id}`);
};

const updateEmailTemplate = ({ id, data }: any) => {
  return http.put(`/admin/update-email-temlate/${id}`, data);
};

const uploadFileBroadcast = (data: any) => {
  return http.post("communication/upload-files", data);
};

const getNewEmailTemplates = () => {
  return http.get("/admin/newEmailTemplates")
}

const createAdminEmailTemplatesInProd = (data: any) => {
  return http.post("admin/createAdminEmailTemplatesInProd", data)
}

const updateAdminEmailTemplatesInProd = (data: any) => {
  return http.post("admin/updateAdminEmailTemplatesInProd", data)
}




export {
  sendEmailTemplateService,
  createEmailTemplatessss,
  getOneEmailTemplate,
  updateEmailTemplate,
  getEmailTemplates,
  deleteEmailTemplate,
  uploadFileBroadcast,
  getNewEmailTemplates,
  createAdminEmailTemplatesInProd,
  updateAdminEmailTemplatesInProd
};
